/**
 * Capability global init defaults (Feature 17).
 *
 * Layer 2 of the capability InitAttr merge (defaults → THIS → per-org).
 * Server validates against the capability's `BaseInitAttr` on PUT; 422
 * on Pydantic violations, 404 when the capability id is not loaded.
 */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type {
  CapabilityGlobalConfig,
  UpsertGlobalConfigBody,
} from '../types.js';

export function getCapabilityGlobalConfig(
  capabilityId: string,
): Promise<CapabilityGlobalConfig> {
  return apiGet<CapabilityGlobalConfig>(
    `/api/v1/admin/capability-global-configs/${capabilityId}`,
  );
}

export function setCapabilityGlobalConfig(
  capabilityId: string,
  body: UpsertGlobalConfigBody,
): Promise<CapabilityGlobalConfig> {
  return apiPut<CapabilityGlobalConfig>(
    `/api/v1/admin/capability-global-configs/${capabilityId}`,
    body,
  );
}

export function deleteCapabilityGlobalConfig(
  capabilityId: string,
): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/capability-global-configs/${capabilityId}`,
  );
}
